import CreateNewCategoryForm from './CreateNewCategoryForm';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


export default function CreateNewMapCategoryModal({
  showModal,
  handleCloseModal,
  dsrId
}) {

  return (
    <LaunchdeckModal
      title='Create new category'
      handleCloseModal={handleCloseModal}
      showModal={showModal}
      maxW='35em'
    >
      <CreateNewCategoryForm
        dsrId={dsrId}
        handleCloseModal={handleCloseModal}
      />
    </LaunchdeckModal>
  )
}